<template>
  <sfs-base-list-filter
    title="Filter Commission Plans"
    :table-name="tableName"
    :applied-filters="appliedFilters"
    :displayed-columns="displayedColumns"
    :available-columns="availableColumns"
    @filters-applied="onFiltersApplied"
    @filters-reset="onDefaultPresetApplied"
    @filter-cleared="onFilterCleared"
    :advanced-filter="false"
    :popover-filter="true"
  >
    <template #quick-filters>
      <b-form-group
        label="Search fields for Data"
        label-for="quick-filter-text"
        label-sr-only
      >
        <b-input-group>
          <b-form-input
            id="quick-filter-text"
            v-model="filters.text"
            type="text"
            placeholder="Filter by Name or User"
            @keydown.enter.native="applyFilters"
          />
          <template #append>
            <b-button
              id="quick-filter-apply-button"
              @click="applyFilters"
              variant="primary"
            >
              <i class="fa fa-search" />
            </b-button>
          </template>
        </b-input-group>
      </b-form-group>
    </template>

    <template #popover-filters>
      <b-row>
        <b-col>
          <b-form-group
            label="Name"
            label-for="popover-filter-name"
            label-cols-lg="5"
          >
            <b-form-input
              id="popover-filter-name"
              v-model="filters.name"
              type="text"
              placeholder="Name"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label="Active?"
            label-for="popover-filter-active"
            content-cols-lg="7"
          >
            <b-form-radio-group
              id="popover-filter-active"
              v-model="filters.active"
              :options="activeOptions"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </sfs-base-list-filter>
</template>
<script>
import { COMMISSION_PLAN_TABLE_COLUMN_OPTIONS, COMMISSION_PLAN_TABLE_DEFAULT_COLUMNS, COMMISSION_PLAN_TABLE_NAME } from '@/constants/commissionPlans';
import listFilterMixin from '@/mixins/listFilterMixin';

export default {
  name: 'CommissionPlansListFilter',
  mixins: [listFilterMixin],
  data() {
    return {
      availableColumns: COMMISSION_PLAN_TABLE_COLUMN_OPTIONS,
      tableName: COMMISSION_PLAN_TABLE_NAME,
    };
  },
  mounted() {
    this.applyFilters();
  },
  methods: {
    onDefaultPresetApplied() {
      this.filters = {};
      this.displayedColumns = COMMISSION_PLAN_TABLE_DEFAULT_COLUMNS;
      this.applyFilters();
    },
  },
};
</script>
